import React from "react";
import { View, StyleSheet, Platform } from "react-native";
import LhButton from "../../components/LhButton";
import LHOverlay from "../../components/LHOverlay";

interface ObservationBeginProps {
  isFilterOverlayVisible: boolean;
  closeFilterOverlay: () => void;
  renderFilterDropdowns: () => React.ReactNode;
  handleSaveFilters: () => void;
}

const ObservationBegin: React.FC<ObservationBeginProps> = ({
  isFilterOverlayVisible,
  closeFilterOverlay,
  renderFilterDropdowns,
  handleSaveFilters,
}) => {
  return (
    <LHOverlay
      visible={isFilterOverlayVisible}
      onDismiss={closeFilterOverlay}
      title="Select Observation Filters"
      size="medium"
    >
      <View style={styles.filterOverlayContainer}>
        {renderFilterDropdowns()}

        <View style={styles.filterOverlayButtons}>
          <LhButton
            testID="cancel-button"
            text="Cancel"
            variant="secondary"
            size="small"
            onPress={closeFilterOverlay}
            isLoading={false}
            disabled={false}
            style={{ ...styles.filterOverlayButton, ...styles.cancelButton }}
          />
          <LhButton
            testID="proceed-button"
            text="Proceed"
            variant="primary"
            size="small"
            onPress={handleSaveFilters}
            isLoading={false}
            disabled={false}
            style={styles.filterOverlayButton}
          />
        </View>
      </View>
    </LHOverlay>
  );
};

const styles = StyleSheet.create({
  filterOverlayContainer: {
    padding: 16,
  },
  filterOverlayButtons: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 20,
    gap: 10,
  },
  filterOverlayButton: {
    width: Platform.OS === "web" ? "15%" : "40%",
    fontSize: 16,
  },
  cancelButton: {
    borderWidth: 0,
  },
});

export default ObservationBegin;
